import { useEffect, useState } from 'react';

/**
 * How much of the bottom of the screen the on-screen keyboard covers.
 *
 * iOS does not shrink the layout viewport for the keyboard: whatever is
 * `position: fixed` to the bottom ends up underneath it. The visual viewport
 * does shrink, so the difference is the height to lift a bottom bar by.
 * 0 where there is no visual viewport API or no keyboard.
 */
export function useKeyboardInset(enabled: boolean): number {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!enabled || !viewport) {
      setInset(0);
      return;
    }
    const update = () =>
      setInset(
        Math.max(
          0,
          Math.round(window.innerHeight - viewport.height - viewport.offsetTop)
        )
      );
    update();
    viewport.addEventListener('resize', update);
    viewport.addEventListener('scroll', update);
    return () => {
      viewport.removeEventListener('resize', update);
      viewport.removeEventListener('scroll', update);
    };
  }, [enabled]);

  return inset;
}
